import { Component, OnInit } from '@angular/core';
import { HRMSService } from './shared/hrms.service';
import { UtilService } from './shared/util.service';
import { UserService } from 'app/users/shared/user.service';
import { PageChangeEvent, GridDataResult } from '@progress/kendo-angular-grid';
import { LogisticsService } from 'app/logistics-operations/shared/logistics.service';
import { DateService } from 'app/date/date.service';

@Component({
  selector: 'app-hrms',
  templateUrl: './hrms.component.html',
  styleUrls: ['./hrms.component.css']
})
export class HrmsComponent implements OnInit {
  upcommingHolidys;
  monthName:any;
  employees:any;
  designations:any;
  branches:any;
  newEmployees:any;
  public pageSize = 10;
  public skip = 0;
  public gridView: GridDataResult;
  todaysLeaveList:any;
  employeeByDepartment:any;
  donutChartData:any;
  branchWiseAttendace:any;
  branchWiseAttendaceArray:any;
  constructor(private hrmsService:HRMSService, private userService:UserService, private ls:LogisticsService, private util: UtilService, private dateService:DateService) { }

  ngOnInit() {
    this.getupCommingHolidays();
    this.getAllDesignations();
    this.getAllBranch();
    this.getAllEmployees();
    this.getTodaysLeave();
    this.getEmployeeByDepartment();
    setTimeout(() => {
      this.getBranchWiseAttendance();
    }, 300);
  }
  public pageChange(event: PageChangeEvent): void {
    this.skip = event.skip;
    this.loadItems();
  }
  getupCommingHolidays()
  {
    this.hrmsService.getAllHolidays().snapshotChanges().subscribe((data)=>{
      this.upcommingHolidys = [];
      data.forEach((holiday)=>{
          if(new Date(holiday.payload.child("date").val()) >= new Date(this.dateService.getTodaysDate()))
          {
            var y = holiday.payload.toJSON();
            y["key"] = holiday.key;
            this.upcommingHolidys.push(y);
          }
      });
      this.upcommingHolidys.sort(function(a,b){
        var c = new Date(a.date);
        var d = new Date(b.date);
        return c.getTime() - d.getTime();
        /* var dateA = new Date(a.date).getTime();
        var dateB = new Date(b.date).getTime();
        return dateA > dateB ? 1 : -1; */  
        });
    });
  }
  getAllEmployees()
  {
    this.userService.getAllUser().snapshotChanges().subscribe((data)=>{
      this.getAllNewEmployees(data);
      this.employees = [];
      data.forEach((user)=>{
        if(user.payload.child("role").val() != 'customer' && user.payload.child("visaExpiryDate").exists())
        {
          //console.log("visa",this.util.getDayDifference(new Date(user.payload.child("visaExpiryDate").val()),new Date()),new Date(user.payload.child("visaExpiryDate").val()),new Date());
            var y = user.payload.toJSON();
            y["key"] = user.key;
            y["days"] = this.util.getDayDifference(new Date(user.payload.child("visaExpiryDate").val()),new Date(this.dateService.getTodaysDate()));
            y["date"] = new Date(user.payload.child("visaExpiryDate").val());
            y["documentType"] = "visa";
            var today = new Date(this.dateService.getTodaysDate());
            var visaExpiryDate = new Date(user.payload.child("visaExpiryDate").val());
            if(user.payload.child("visaExpiryDate").val()!= '' && visaExpiryDate.getTime() >= today.getTime())
            {
              y["expiryDate"] = this.dateService.getFullDate(user.payload.child("visaExpiryDate").val());
              this.employees.push(y);
            }
        }
        if(user.payload.child("role").val() != 'customer' && user.payload.child("iqamaExpiryDate").exists())
        {
          //console.log("visa",this.util.getDayDifference(new Date(user.payload.child("visaExpiryDate").val()),new Date()),new Date(user.payload.child("visaExpiryDate").val()),new Date());
            var y = user.payload.toJSON();
            y["key"] = user.key;
            y["days"] = this.util.getDayDifference(new Date(user.payload.child("iqamaExpiryDate").val()),new Date(this.dateService.getTodaysDate()));
            y["date"] = new Date(user.payload.child("iqamaExpiryDate").val());
            y["documentType"] = "iqama";
            var today = new Date(this.dateService.getTodaysDate());
            var iqamaExpiryDate = new Date(user.payload.child("iqamaExpiryDate").val());
            if(user.payload.child("iqamaExpiryDate").val()!= '' && iqamaExpiryDate.getTime() >= today.getTime())
            {
              y["expiryDate"] = this.dateService.getFullDate(user.payload.child("iqamaExpiryDate").val());
              this.employees.push(y);
            }
        }
      });
      //console.log("employees data",this.employees);
      this.employees.sort(function(a,b){
        return a.date.getTime() - b.date.getTime();
        });
      this.loadItems();
  });
}
private loadItems():void{
  this.gridView = {
    data: this.employees.slice(this.skip, this.skip + this.pageSize),
    total: this.employees.length
  };
}
getAllNewEmployees(data)
{
  this.newEmployees = [];
  data.forEach((user)=>{
    if(user.payload.child("role").val() != 'customer' && user.payload.child("createdAt").exists())
      {
        var d1 = user.payload.child("createdAt").val().split("/");
        var date = new Date(Number(d1[2]), parseInt(d1[1]) - 1, Number(d1[0]));
        //console.log("createdAt",user.payload.child("name").val(),this.util.getDayDifference(new Date(date),new Date()));
        var y = user.payload.toJSON();
        y["key"] = user.key;
        y["days"] = this.util.getDayDifference(new Date(date),new Date());
        this.newEmployees.push(y);
      }
      });
    this.newEmployees.sort(function(a,b){
    return a.days - b.days;
    });
    setTimeout(() => {
      //console.log("newEmployees",this.newEmployees);
    }, 300);
}
public getAllDesignations()
{
  var x = this.hrmsService.getAllDesignations();
  x.snapshotChanges().subscribe(item=>{
  this.designations = [];
    item.forEach(element =>{
        this.designations[element.key] = element.payload.child("name").val();
    });
  });
}
getAllBranch()
{
  this.ls.getBranch().snapshotChanges().subscribe(data=>{
    this.branches  = [];
    data.forEach(branch=>{
      this.branches[branch.key] = branch.payload.child("name").val();
    });
  });
}
getTodaysLeave()
{
  this.hrmsService.getEmployeesLeaveList().snapshotChanges().subscribe((data)=>{
    this.todaysLeaveList = [];
    var userArry = [];
    data.forEach(leave=>{
      //console.log(this.util.checkDatesFromTo(leave.payload.child("from").val(),leave.payload.child("to").val(), this.dateService.getTimeandDate().date));
      if(this.util.checkDatesFromTo(leave.payload.child("from").val(),leave.payload.child("to").val(), this.dateService.getTimeandDate().date))
      {
        this.userService.getUser(leave.payload.child("uid").val()).once("value").then((user)=>{
          if(!userArry.includes(user.key))
          {
            this.todaysLeaveList.push(user.val());
            userArry.push(user.key);
          }
        });
      }
    });
  });
}
getEmployeeByDepartment()
{
  this.hrmsService.getAllDepartments().snapshotChanges().subscribe((data)=>{
    this.employeeByDepartment = [];
    var departments = [];
    departments.push(['Task', 'Hours per Day']);
    data.forEach(d=>{
      var users = [];
      this.userService.getUserOfDepartment(d.key).once("value").then((user)=>{
        //console.log("user.numChildren()",user.numChildren());
        this.employeeByDepartment.push({
          deparment : d.payload.child("name").val(),
          employeeCount : user.numChildren()
        });
        users.push(d.payload.child("name").val());
        users.push(user.numChildren());
        departments.push(users);
      });
    });
    setTimeout(() => {
      //console.log("departments",departments);
      this.donutChartData =  {
        chartType: 'PieChart',
        dataTable: departments,
        options: {
          height: 320,
          title: 'Employees',
          pieHole: 0.4,
          colors: ['#d786ef', '#5d3d67', '#b5a6b9', '#5D9CEC', '#5FBEAA', '#FF552A', '#FF00AA', '#00D5D5']
        },
      };
    }, 500);
  });
}
getBranchWiseAttendance()
{
  this.branchWiseAttendace = [];
  for(let i in this.branches)
  {
    this.hrmsService.getAllEmployeesOfBranch(i).snapshotChanges().subscribe((users)=>{   
      var branchAttendaceCount = 0;
      var userCount = 0;
      //console.log("uc",users.length);
      users.forEach(user=>{
        userCount++;
        if(user.payload.child("employeeId").exists())
        {
        this.hrmsService.getUsersTodaysAttendance(user.payload.child("employeeId").val()).once("value").then((logs)=>{
          logs.forEach(log=>{
            if(log.child("clockIn").val() != '')
            {
              branchAttendaceCount++;
            }
            this.branchWiseAttendace[i] = {
              branch: this.branches[i],
              count: branchAttendaceCount,
              uc: userCount
            };
            this.convertToArray();
          });
      });
    }
    });
  });
}
}
search(term:string) {
  let promise = new Promise((resolve, reject) => {
    //TODO
  });
  return promise;
}
convertToArray()
{
  this.branchWiseAttendaceArray = [];
  if(Object.keys(this.branchWiseAttendace).length > 0)
  {
    for(let i in this.branchWiseAttendace)
    {
      this.branchWiseAttendaceArray.push({
        branch: this.branchWiseAttendace[i].branch,
        count: this.branchWiseAttendace[i].count,
        userCount: this.branchWiseAttendace[i].uc
      });
      //console.log("userCount",this.branchWiseAttendace[i].uc);
    }
  }
}
}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/hrms/hrms.component.ts